import { StoresModel } from '@/modules/stores/stores-model';

const { fields } = StoresModel;

export default [
  fields.id,

  fields.createdAt
];
